
<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
export default {
  extends: Line,
  mixins: [ mixins.reactiveProp ],
  name: 'histgram',
  props: ['chartData', 'options'],
  watch: {
    'options': {
      handler (newOption, oldOption) {
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    },
  },
  mounted () {
    
    const dataset = this.chartData
    const options = this.options
    this.renderChart(dataset, options)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/histgram.vue